export default __webpack_public_path__ + "static/media/NexaBold.c2b99812.otf";